var buttons = document.querySelectorAll(".lets-talk");
var slideOverlay = document.querySelector(".slideOverlay");
var body = document.body;
var slideModal = document.querySelector(".contact-form-slide");
var slideClose = document.querySelector(".contact-form-close");
var lastButton;

TweenMax.set([slideOverlay], { autoAlpha: 0 });

console.log(window.innerWidth);

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", function(event) {
    event.preventDefault();
    slideIn();
  });
}

function slideIn() {
  lastButton = this;

  var show = new TimelineMax();

  console.log(window.innerWidth);

  if (window.innerWidth < 992) {
    console.log('is mobile');
    show.to(slideModal, 0.5, {
      transform: "translate(-830px, 0%) matrix(1, 0, 0, 1, 830, 0)"
    });
  } else {
    console.log('is not mobile');
    show.to(slideModal, 0.5, {
      xPercent: -100
    });
  }
  show.to(slideOverlay, 0.2, { autoAlpha: 0.4 });
  body.classList.add("no-scroll");
  slideModal.classList.add('contact-form-slide--open');
}

if (slideOverlay) {
  slideOverlay.addEventListener("click", function() {
    var hide = new TimelineMax();

    hide.to(slideModal, 0.5, {
      xPercent: 0
    });
    hide.to(".slideOverlay", 0.3, { autoAlpha: 0 });

    body.classList.remove("no-scroll");
    slideModal.classList.remove('contact-form-slide--open');
  });

  slideClose.addEventListener("click", function() {
    var hide = new TimelineMax();

    if (window.innerWidth < 992) {
      hide.to(slideModal, 0.5, {
        transform: "matrix(0, 0, 0, 0, 0, 0)"
      });
    } else {
      hide.to(slideModal, 0.5, {
        xPercent: 0
      });
    }
    hide.to(".slideOverlay", 0.3, { autoAlpha: 0 });

    body.classList.remove("no-scroll");
    slideModal.classList.remove('contact-form-slide--open');
  });
}
